import React, { useCallback, useState } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Checkbox, CheckboxLabel, CheckboxCount, ShowButton } from './styles';

interface Value {
  label?: string;
  text: string;
  count: number;
}

interface Props {
  options: Value[];
  values: string[];
  hideAfter?: number;
  allowSelectOne?: boolean;
  onChange: (values: string[]) => void;
  onOptionChange?: (value: string, isChecked: boolean) => void;
}

const Select = ({ options, values, hideAfter = 5, allowSelectOne = false, onChange, onOptionChange }: Props) => {
  const { t } = useStoreTranslation();

  const [showAll, setShowAll] = useState(false);

  const isChecked = useCallback((checkValue: string) => Boolean(values.find((item) => item === checkValue)), [values]);

  const handleChange = (newValue: string) => {
    if (isChecked(newValue)) {
      onChange(values.filter((item) => item !== newValue));
    } else {
      onChange([...values, newValue]);
    }
    if (onOptionChange) onOptionChange(newValue, !isChecked(newValue));
  };

  return (
    <Container>
      {options.slice(0, showAll ? options.length : hideAfter).map((option, index) => {
        const isDisabled = allowSelectOne && values.length > 0 && !values.includes(option.text);

        return (
          <Checkbox
            key={index}
            checked={isChecked(option.text)}
            onChange={() => handleChange(option.text)}
            disabled={isDisabled}
          >
            <CheckboxLabel
              $disabled={isDisabled}
              onClick={() => handleChange(option.text)}
              content={option.label || option.text}
            />
            <CheckboxCount>{option.count}</CheckboxCount>
          </Checkbox>
        );
      })}
      {options.length > hideAfter && (
        <ShowButton onClick={() => setShowAll((s) => !s)}>
          {showAll ? t('hotelsFilters.select.showLess') : t('hotelsFilters.select.showMore')}
        </ShowButton>
      )}
    </Container>
  );
};

export default Select;
